import React from "react";
import MyWalletFavItem from "./MyWalletFavItem";
import MyWalletItem from "./MyWalletItem";

const MyWallet = () => {
    return (
        <>
            <div>
                <div className="_creator_top_wrap _wallet_nft_main_top_wrap">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="_stats_title_wrap">
                                    <h2 className="_creator_title _wallet_header_title">My Wallet <img src="assets/img/wallet.svg" alt="pic" className="_wallet_header_img" /></h2>
                                    <p className="_creator_txt _wallet_header_txt">Welcome to AllBlocks wallet page</p>
                                </div>
                            </div>
                        </div>
                        <div className="_wallet_main_wrapper">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div className="_wallet_main_heading">
                                        <div className="row align-items-center">
                                            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                                <h6 className="_wallet_main_heading_title">Assets</h6>
                                            </div>
                                            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                                                <div className="_wallet_main_heading_title_right">
                                                    <h6 className="_wallet_main_heading_title">Main Wallet</h6>
                                                    <button className="_wallet_main_heading_btn">Add New Wallet</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <MyWalletItem/>
                        </div>
                    </div>
                </div>
                <div className="_wallet_btm_table_wrap">
                    <h2 className="_creator_title _wallet_header_title">Latest Transaction</h2>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="_fav_table_item_header">
                                    <ul className="_fav_table_item_header_main">
                                        <li className="_fav_table_header_item">
                                            <input type="checkbox" name="colcheck" id="colcheck" className="colcheck_input" />
                                            <label htmlFor="colcheck" className="_fav_table_header_colcheck">Collections</label>
                                        </li>
                                        <li className="_fav_table_header_item">
                                            Type
                                        </li>
                                        <li className="_fav_table_header_item">
                                            Amount
                                        </li>
                                        <li className="_fav_table_header_item">
                                            Date &amp; Time
                                        </li>
                                        <li className="_fav_table_header_item">
                                            Action
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="_nft_settings_main_bottom_body _wallet_table_btm_main">
                                    <div className="row my-3">
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                            <MyWalletFavItem/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default MyWallet;